import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtolonadacab() {



    const cardData = {




keyword: "Belgaum to Londa Cab",

headingDescription: "Belgaum Taxi Service provides comfortable and reliable Belgaum to Londa cab services for family trips, railway travel, business visits, nature tours, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Londa, we offer safe and convenient transportation with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel needs. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth journey. Belgaum Taxi Service connects passengers between Belgaum and Londa with affordable and comfortable cab solutions for tourists, families, and travelers exploring Karnataka and nearby destinations.",

topPlaces: [
  {
    title: "Londa",
    description: "Londa is a scenic town near the Karnataka-Goa border, known for forests, railway connectivity, and peaceful natural surroundings. It is a popular destination for nature lovers and travelers."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a famous adventure destination near Londa, known for wildlife sanctuary, river rafting, jungle safari, and outdoor activities, making it ideal for family and group trips."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination near Londa, famous for beaches, resorts, churches, and sightseeing attractions. Private cabs provide comfortable travel for tourists."
  },
  {
    title: "Castle Rock",
    description: "Castle Rock is a beautiful nature destination near Londa known for waterfalls, forests, trekking routes, and scenic landscapes, attracting adventure travelers."
  },
  {
    title: "Amboli",
    description: "Amboli is a peaceful hill station in Maharashtra known for waterfalls, greenery, misty hills, and natural beauty, making it a popular weekend getaway."
  },
  {
    title: "Belagavi Airport",
    description: "Belagavi Airport provides air connectivity for travelers from Belgaum and nearby regions. Taxi services offer convenient airport transfers from Londa and surrounding areas."
  },
  {
    title: "Hubballi",
    description: "Hubballi is an important commercial city in Karnataka known for business, education, and healthcare facilities, offering convenient connectivity from Londa."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and business hub in Maharashtra. Travelers prefer private cabs for comfortable long-distance journeys."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital with major business areas, airports, and tourist attractions. Cab services provide reliable interstate travel options."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site famous for ancient ruins, temples, and historical monuments, making it a popular heritage destination in Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Londa Cabs",
    "description": "Book Belgaum to Londa Cabs for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Get convenient cab services for local travel, railway station transfers, family trips, business visits, and nearby destinations with flexible booking options."
  },
  {
    "name": "Belgaum to Londa Taxi",
    "description": "Hire Belgaum to Londa Taxi for affordable and comfortable transportation between both locations. Choose from Sedan, Ertiga, Innova Crysta, and SUV taxis with experienced drivers and smooth travel facilities."
  },
  {
    "name": "Belgaum to Londa Cab Service",
    "description": "Choose Belgaum to Londa Cab Service for dependable travel solutions with doorstep pickup, transparent pricing, and professional chauffeurs. Our cabs are suitable for personal travel, business trips, family journeys, and local transportation needs."
  },
  {
    "name": "Belgaum to Londa Taxi Service",
    "description": "Book Belgaum to Londa Taxi Service for comfortable and hassle-free journeys. Enjoy clean AC vehicles, trained drivers, affordable fares, and reliable taxi options for one way and round trip travel."
  },
  {
    "name": "Belgaum to Londa One Way Cab",
    "description": "Reserve Belgaum to Londa One Way Cab for economical point-to-point travel without return charges. Get fixed pricing, comfortable vehicles, and professional driver assistance for a smooth journey."
  },
  {
    "name": "Belgaum to Londa Cab Booking",
    "description": "Complete Belgaum to Londa Cab Booking with easy online reservations and quick confirmation. Select your preferred vehicle according to passenger requirements, luggage space, and travel comfort."
  },
  {
    "name": "Belgaum to Londa Taxi Booking",
    "description": "Book Belgaum to Londa Taxi Booking services for convenient and reliable transportation. Enjoy affordable rates, flexible pickup locations, and experienced chauffeurs for safe travel."
  },
  {
    "name": "Belgaum to Londa Car Rental",
    "description": "Choose Belgaum to Londa Car Rental with driver for flexible travel solutions. Hire comfortable cars for family visits, sightseeing, business travel, and personal transportation."
  },
  {
    "name": "Belgaum to Londa Outstation Cab",
    "description": "Travel with Belgaum to Londa Outstation Cab services offering safe and comfortable intercity transportation. Get reliable vehicles, professional drivers, and flexible one way or round trip options."
  },
  {
    "name": "Belgaum to Londa Innova Crysta Cab",
    "description": "Book Belgaum to Londa Innova Crysta Cab for premium and spacious travel. Enjoy luxury seating, extra luggage capacity, and comfortable rides for families, groups, and corporate passengers."
  },
  {
    "name": "Belgaum to Londa Ertiga Cab",
    "description": "Hire Belgaum to Londa Ertiga Cab for affordable 6 to 7 seater travel. Perfect for family trips, group journeys, airport transfers, and comfortable outstation transportation."
  },
  {
    "name": "Belgaum to Londa Sedan Cab",
    "description": "Choose Belgaum to Londa Sedan Cab for economical and comfortable travel. Enjoy clean AC sedans with professional drivers suitable for business trips, personal visits, and daily transportation."
  },
  {
    "name": "Belgaum to Londa Round Trip Cab",
    "description": "Book Belgaum to Londa Round Trip Cab for convenient return journeys with affordable travel packages. Ideal for family outings, sightseeing, business visits, and planned trips."
  },
  {
    "name": "Belgaum to Londa Private Taxi",
    "description": "Hire Belgaum to Londa Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and flexible travel schedules."
  },
  {
    "name": "Cheap Belgaum to Londa Cab",
    "description": "Find Cheap Belgaum to Londa Cab services offering affordable fares with quality vehicles and reliable drivers. Travel comfortably with budget-friendly taxi solutions without compromising safety."
  },
  {
    "name": "Best Belgaum to Londa Cab Service",
    "description": "Choose the Best Belgaum to Londa Cab Service with premium vehicles, experienced chauffeurs, and competitive pricing. Get dependable transportation for families, individuals, and business travelers."
  },
  {
    "name": "Online Belgaum to Londa Cab Booking",
    "description": "Book Online Belgaum to Londa Cab Booking services with easy reservations and instant confirmation. Select from multiple vehicle options for comfortable and convenient travel."
  },
  {
    "name": "Belgaum to Londa Taxi Fare",
    "description": "Get affordable Belgaum to Londa Taxi Fare with transparent pricing and flexible packages. Choose suitable vehicles based on passenger count and travel requirements."
  },
  {
    "name": "Belgaum to Londa Car Hire",
    "description": "Hire Belgaum to Londa Car Hire services with reliable vehicles and professional drivers. Suitable for family travel, corporate visits, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Londa Cab Price",
    "description": "Check Belgaum to Londa Cab Price and select affordable travel options. Get comfortable AC cabs with flexible booking facilities for one way and round trip journeys."
  },
  {
    "name": "Belgaum to Londa Family Cab",
    "description": "Book Belgaum to Londa Family Cab for safe and spacious travel. Enjoy comfortable seating, experienced drivers, and convenient transportation for family trips and personal visits."
  },
  {
    "name": "Belgaum to Londa Corporate Taxi",
    "description": "Choose Belgaum to Londa Corporate Taxi services for business travel and professional transportation. Get reliable vehicles, punctual service, and experienced chauffeurs for corporate requirements."
  },
  {
    "name": "Belgaum to Londa Railway Station Cab",
    "description": "Book Belgaum to Londa Railway Station Cab for timely pickup and drop services. Travel comfortably with professional drivers and well-maintained vehicles for railway station transfers."
  },
  {
    "name": "Belgaum to Londa Cab Fare",
    "description": "Get details about Belgaum to Londa Cab Fare with affordable rates and multiple vehicle choices. Book Sedan, Ertiga, Innova Crysta, or SUV cabs according to your travel needs."
  },
  {
    "name": "Belgaum to Londa Taxi Near Me",
    "description": "Find Belgaum to Londa Taxi Near Me for quick and reliable taxi availability. Book comfortable cabs with experienced drivers for safe and convenient transportation."
  },
  {
    "name": "Belgaum to Londa Outstation Taxi",
    "description": "Hire Belgaum to Londa Outstation Taxi for comfortable long-distance travel with clean vehicles and professional chauffeurs. Enjoy reliable transportation for personal, family, and business journeys."
  },
  {
    "name": "Belgaum to Londa Travel by Cab",
    "description": "Travel from Belgaum to Londa by Cab with convenient booking options, comfortable vehicles, and experienced drivers. Enjoy smooth and stress-free transportation for your complete journey."
  },
  {
    "name": "Londa to Dandeli Taxi",
    "description": "Book Londa to Dandeli Taxi for comfortable sightseeing and travel with professional drivers. Enjoy convenient transportation to Dandeli with reliable vehicles suitable for families, groups, and tourists."
  },
  {
    "name": "Cab Service in Londa",
    "description": "Choose Cab Service in Londa for reliable local and outstation transportation. Get clean vehicles, experienced drivers, affordable pricing, and flexible cab options for personal and business travel."
  }
],
"tableData": [
  ["Belgaum to Londa Cabs", "Belgaum to Londa Taxi"],
  ["Belgaum to Londa Cab Service", "Belgaum to Londa Taxi Service"],
  ["Belgaum to Londa One Way Cab", "Belgaum to Londa Cab Booking"],
  ["Belgaum to Londa Taxi Booking", "Belgaum to Londa Car Rental"],
  ["Belgaum to Londa Outstation Cab", "Belgaum to Londa Innova Crysta Cab"],
  ["Belgaum to Londa Ertiga Cab", "Belgaum to Londa Sedan Cab"],
  ["Belgaum to Londa Round Trip Cab", "Belgaum to Londa Private Taxi"],
  ["Cheap Belgaum to Londa Cab", "Best Belgaum to Londa Cab Service"],
  ["Online Belgaum to Londa Cab Booking", "Belgaum to Londa Taxi Fare"],
  ["Belgaum to Londa Car Hire", "Belgaum to Londa Cab Price"],
  ["Belgaum to Londa Family Cab", "Belgaum to Londa Corporate Taxi"],
  ["Belgaum to Londa Railway Station Cab", "Belgaum to Londa Cab Fare"],
  ["Belgaum to Londa Taxi Near Me", "Belgaum to Londa Outstation Taxi"],
  ["Belgaum to Londa Travel by Cab", "Londa to Dandeli Taxi"],
  ["Cab Service in Londa", ""]
],





whychoose: [
  {
    WhyChooseheading: "Convenient Belgaum to Londa Cab Service",
    WhyChoosedescription: "Make your journey from Belgaum to Londa simple and comfortable with well-maintained taxis, experienced drivers, and flexible travel options for personal and business requirements."
  },
  {
    WhyChooseheading: "Smooth Travel Between Belgaum & Londa",
    WhyChoosedescription: "Enjoy direct pickup and drop facilities with a hassle-free travel experience designed for passengers looking for reliable local route connectivity."
  },
  {
    WhyChooseheading: "Cab Choices for Every Passenger",
    WhyChoosedescription: "Select from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV vehicles based on your group size and comfort preferences."
  },
  {
    WhyChooseheading: "Suitable for Daily & Outstation Needs",
    WhyChoosedescription: "Our taxis are ideal for family visits, business travel, railway station transfers, local work trips, and personal transportation."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Rides",
    WhyChoosedescription: "Experienced chauffeurs provide timely service, smooth driving, and comfortable travel with proper knowledge of the Belgaum to Londa route."
  },
  {
    WhyChooseheading: "Flexible One Way & Return Booking",
    WhyChoosedescription: "Choose a direct one-way cab or plan a return journey according to your timing and travel requirements."
  },
  {
    WhyChooseheading: "Affordable Taxi Travel Options",
    WhyChoosedescription: "Get suitable vehicle options with transparent pricing and convenient packages for a comfortable Belgaum to Londa journey."
  },
  {
    WhyChooseheading: "Quick Booking Assistance",
    WhyChoosedescription: "Receive support for cab availability, fare enquiries, vehicle selection, and travel planning whenever you need."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Londa Cab Service?",
    answer: "Yes, we provide Belgaum to Londa cab services with comfortable vehicles and professional drivers for convenient travel."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Londa?",
    answer: "Yes, one-way cab services are available for passengers who need direct transportation between Belgaum and Londa."
  },
  {
    question: "Which vehicles are available for Belgaum to Londa travel?",
    answer: "You can choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs according to your requirements."
  },
  {
    question: "Is Belgaum to Londa taxi suitable for family travel?",
    answer: "Yes, spacious and comfortable vehicles are available for families and groups travelling between Belgaum and Londa."
  },
  {
    question: "Can I book a return cab from Londa to Belgaum?",
    answer: "Yes, return trip taxi options are available with flexible schedules based on your travel plans."
  },
  {
    question: "Do you provide pickup from Belgaum Airport or Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Londa?",
    answer: "Yes, private cab services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Additional charges such as toll, parking, and other applicable fees depend on the selected travel package and are explained during booking."
  },
  {
    question: "Is Belgaum to Londa cab service available anytime?",
    answer: "Yes, booking assistance is available for planned journeys and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Londa Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to get fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Desai",
    feedback: "The Belgaum to Londa cab service was smooth and convenient. The driver was punctual, and the vehicle provided a comfortable journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rupa Kulkarni",
    feedback: "A great travel experience with clean interiors and professional service. The cab made our trip between Belgaum and Londa easy and comfortable.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Londa Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-londa-cab.webp",
  "description":
    "Book Belgaum to Londa Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Londa with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, sightseeing trips, business journeys, and outstation transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-londa-cab"
  }
};




    return (
        <div>



<Helmet>
  <title>Belgaum to Londa Cab | Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Londa Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Londa with Sedan, Ertiga, SUV, Innova, and Innova Crysta for local travel, sightseeing, and outstation journeys available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Londa Cabs, Belgaum to Londa Taxi, Belgaum to Londa Cab Service, Belgaum to Londa Taxi Service, Belgaum to Londa One Way Cab, Belgaum to Londa Cab Booking, Belgaum to Londa Taxi Booking, Belgaum to Londa Car Rental, Belgaum to Londa Outstation Cab, Belgaum to Londa Taxi Fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtolonadacab;